import LoginInformation from './LoginInformation';

export default LoginInformation;
